import z from 'zod';
import { MANDATORY_FIELD } from '../../config/zodConfig';
import zod from 'zod';

export const DeviceGroupFormSchema = z.object({
  id: z.number().optional(),
  name: z.string().min(1, MANDATORY_FIELD),
  Devices: zod.array(zod.number()).min(1, MANDATORY_FIELD),
  isActive:z.boolean().default(true),
});
